export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "numeric" }) : "—";

export const OrdersTable = ({ orders }) => (
  <div className="card-soft overflow-x-auto" data-testid="admin-orders-table">
    <table className="w-full text-sm">
      <thead>
        <tr className="text-left text-xs uppercase tracking-widest text-slate-500 border-b border-slate-200">
          <th className="px-5 py-4">Professionnel</th><th className="px-5 py-4">Email</th><th className="px-5 py-4">Formation commandée</th><th className="px-5 py-4">Durée</th><th className="px-5 py-4">Progression</th><th className="px-5 py-4">Date</th>
        </tr>
      </thead>
      <tbody>
        {orders.map((o) => (
          <tr key={`${o.user_email}-${o.formation_title}-${o.created_at}`} className="border-b border-slate-100 last:border-0">
            <td className="px-5 py-3.5 font-medium text-slate-900">{o.user_name || "—"}</td>
            <td className="px-5 py-3.5"><a href={`mailto:${o.user_email}`} className="text-brand-700 hover:underline">{o.user_email}</a></td>
            <td className="px-5 py-3.5">{o.formation_title}</td>
            <td className="px-5 py-3.5">{o.duration_days} jours</td>
            <td className="px-5 py-3.5">{o.progress}%</td>
            <td className="px-5 py-3.5 text-slate-500">{fmtDate(o.created_at)}</td>
          </tr>
        ))}
        {!orders.length && <tr><td colSpan={6} className="px-5 py-10 text-center text-slate-500">Aucune commande pour le moment.</td></tr>}
      </tbody>
    </table>
  </div>
);

export const ContactsList = ({ contacts }) => (
  <div className="grid gap-4" data-testid="admin-contacts-list">
    {contacts.map((c) => (
      <div key={`${c.email}-${c.created_at}`} className="card-soft p-6">
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div className="font-semibold text-slate-900">{c.name} <a href={`mailto:${c.email}`} className="text-brand-700 font-normal hover:underline">· {c.email}</a></div>
          <div className="flex items-center gap-3 text-xs text-slate-500">
            {c.interest && <span className="uppercase tracking-widest font-bold text-brand-700 bg-brand-50 rounded-full px-2.5 py-1">{c.interest}</span>}
            {fmtDate(c.created_at)}
          </div>
        </div>
        {c.structure && <div className="text-xs text-slate-500 mt-1">Structure : {c.structure}</div>}
        <p className="text-sm text-slate-700 mt-3 leading-relaxed">{c.message}</p>
      </div>
    ))}
    {!contacts.length && <div className="card-soft p-10 text-center text-slate-500">Aucun message pour le moment.</div>}
  </div>
);

export const SharesPanel = ({ data }) => {
  if (!data) return <div className="card-soft p-10 text-center text-slate-500">Chargement…</div>;
  const stats = [
    { label: "Guides partagés", value: data.total_shares },
    { label: "Guides débloqués", value: data.total_unlocked },
    { label: "Contacts gagnés", value: data.total_contacts },
  ];
  return (
    <div data-testid="admin-shares-panel">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        {stats.map((s) => (
          <div key={s.label} className="card-soft p-6" data-testid={`shares-stat-${s.label.toLowerCase().replace(/ /g, "-")}`}>
            <div className="font-display text-3xl font-bold text-brand-600">{s.value}</div>
            <div className="text-xs uppercase tracking-widest text-slate-500 mt-1.5">{s.label}</div>
          </div>
        ))}
      </div>
      <div className="card-soft overflow-x-auto" data-testid="admin-shares-table">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs uppercase tracking-widest text-slate-500 border-b border-slate-200">
              <th className="px-5 py-4">Guide</th><th className="px-5 py-4">Destinataire</th><th className="px-5 py-4">Envoyé par</th><th className="px-5 py-4">Date</th><th className="px-5 py-4">Statut</th>
            </tr>
          </thead>
          <tbody>
            {data.shares.map((s) => (
              <tr key={s.id} className="border-b border-slate-100 last:border-0">
                <td className="px-5 py-3.5 font-medium text-slate-900">{s.guide_title}</td>
                <td className="px-5 py-3.5"><a href={`mailto:${s.recipient_email}`} className="text-brand-700 hover:underline">{s.recipient_email}</a></td>
                <td className="px-5 py-3.5">{s.sender_name || "—"}</td>
                <td className="px-5 py-3.5 text-slate-500">{fmtDate(s.created_at)}</td>
                <td className="px-5 py-3.5">
                  {s.unlocked
                    ? <span className="text-xs font-bold uppercase tracking-widest rounded-full px-2.5 py-1 bg-emerald-100 text-emerald-700">Débloqué</span>
                    : <span className="text-xs font-bold uppercase tracking-widest rounded-full px-2.5 py-1 bg-slate-100 text-slate-500">En attente</span>}
                </td>
              </tr>
            ))}
            {!data.shares.length && <tr><td colSpan={5} className="px-5 py-10 text-center text-slate-500">Aucun partage pour le moment.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export const LeadsTable = ({ leads }) => (
  <div className="card-soft overflow-x-auto" data-testid="admin-leads-table">
    <table className="w-full text-sm">
      <thead>
        <tr className="text-left text-xs uppercase tracking-widest text-slate-500 border-b border-slate-200">
          <th className="px-5 py-4">Email</th><th className="px-5 py-4">Prénom</th><th className="px-5 py-4">Profession</th><th className="px-5 py-4">Source</th><th className="px-5 py-4">Date</th>
        </tr>
      </thead>
      <tbody>
        {leads.map((l) => (
          <tr key={`${l.email}-${l.created_at || l.downloaded_at || ""}`} className="border-b border-slate-100 last:border-0">
            <td className="px-5 py-3.5"><a href={`mailto:${l.email}`} className="text-brand-700 hover:underline">{l.email}</a></td>
            <td className="px-5 py-3.5">{l.name || "—"}</td>
            <td className="px-5 py-3.5">{l.profession || "—"}</td>
            <td className="px-5 py-3.5 text-slate-500">{l.source || "guide"}</td>
            <td className="px-5 py-3.5 text-slate-500">{fmtDate(l.created_at)}</td>
          </tr>
        ))}
        {!leads.length && <tr><td colSpan={5} className="px-5 py-10 text-center text-slate-500">Aucun lead pour le moment.</td></tr>}
      </tbody>
    </table>
  </div>
);
